import { WindowLocation } from "@reach/router"

export const getKey = (key: string) => (location: WindowLocation) =>
  new URLSearchParams(location.search).get(key)
